import cx from 'classnames';
import type { PropsWithChildren } from 'react';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';

type Props = PropsWithChildren<{
  className?: string;
  style?: React.CSSProperties;
}>;

const InputWrapper = ({ className, children, style = {} }: Props) => {
  const { classes } = useWebThemeContext();

  return (
    <div style={style} className={cx('flex w-full flex-col items-center sm:flex-row', className, classes.radius)}>
      {children}
    </div>
  );
};

export default InputWrapper;
